import React, { useContext, useEffect, useState } from 'react'
import Sidebar from './Sidebar'
import User from '../Pages/User'
import { AuthContext } from '../Context/AuthContext'
import Authentication from '../Authentication'
import Dashboard from '../Pages/Dashboard'
import ApplicationList from '../Pages/ApplicationList'
import {
    BrowserRouter as Router,
    Route,
    Routes
} from "react-router-dom";
import ApplicationView from '../Pages/User/View'
import {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    UploadOutlined,
    UserOutlined,
    VideoCameraOutlined,
} from '@ant-design/icons';
import { Layout, Menu, Button, theme } from 'antd';
import useWindowDimensions from '../Utility/useWindowDimensions'
import ForgotPassword from '../Authentication/ForgotPassword'
import LoginForm from '../Authentication/LoginForm'
import Profile from '../Pages/profile'
import OTPForm from '../Authentication/OTPForm'

const { Header, Sider, Content } = Layout;

function AppLayout() {
    const { width } = useWindowDimensions();
    const [collapsed, setCollapsed] = useState(true);

    const auth = useContext(AuthContext);
    const [userLogin, setUserLogin] = useState(undefined);


    useEffect(() => {
        setUserLogin(auth.userToken)
        // width > 991 ? setCollapsed(false) : setCollapsed(true)
    }, [auth.userToken])

    if (userLogin === undefined) {
        return (
            <Router>
                <Routes>
                    <Route path="/" element={<Authentication />} >
                        <Route
                            path="/"
                            element={<LoginForm />}
                        />
                        <Route path="forgot-password" element={<ForgotPassword />} />
                        <Route path="otp-verify" element={<OTPForm />} />
                    </Route>
                </Routes>
            </Router>


        )

    }
    else {
        return (
            <Router>
                {/* <div className='main-wrapper'>
                    <Sidebar />
                    <div className='page-content'>
                        <Routes>
                            <Route path="/" element={<Dashboard />} />
                            <Route path="/create-application" element={<User />} />
                            <Route path="/application-list" element={<ApplicationList />} />
                            <Route path="/application-list/:id" element={<ApplicationView />} />
                        </Routes>
                    </div>
                </div> */}

                <Layout className={`main-wrapper ${collapsed && 'sidebar-collapsed'}`}>
                    <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
                    <Layout>
                        <Content className='page-content'>
                            <Routes>
                                <Route path="/" element={<Dashboard />} />
                                <Route path="/create-application" element={<User />} />
                                <Route path="/application-list" element={<ApplicationList />} />
                                <Route path="/application-list/:id" element={<ApplicationView />} />
                                <Route path="/my-profile" element={<Profile />} />
                                {/* <Route path="/create-application/edit/:id" element={<User />} /> */}
                            </Routes>
                        </Content>
                    </Layout>
                </Layout>
            </Router>
        )
    }
}

export default AppLayout